import clsx from 'clsx';

import ForecastIcon from '@/components/ForecastIcon';
import { HourlyForecast } from '@/models/HourlyForecast';
import { isDarkMode } from '@/utils/CheckDarkMode';
import { addLeadingZero } from '@/utils/DateUtils';

type HourlyScrollItemProps = Pick<HourlyForecast, 'temperature' | 'icon' | 'time' | 'description'>;

const HourlyScrollItem = ({ temperature, icon, time, description }: HourlyScrollItemProps) => {
  const isDark = isDarkMode(+time);

  return (
    <div
      className={clsx(
        'relative h-full w-full rounded-md bg-blue-300/30 dark:bg-blue-800/50 lg:rounded-lg',
        isDark && 'dark'
      )}
      data-testid="hourlyScrollItem"
    >
      <div className="radial-gradient dark:radial-gradient-dark absolute inset-y-0 w-full rounded-md lg:rounded-lg">
        <div className="pt-2 pb-0.5 text-center text-base font-medium text-grey-900 dark:text-white lg:text-lg">
          {temperature}&deg;
        </div>
        <ForecastIcon iconName={icon} isDark={isDark} className="mx-auto h-9 w-9 lg:h-10 lg:w-10" alt={description} />
        <div className="pt-1 text-center text-sm text-grey-800 dark:text-white">{`${addLeadingZero(+time)}:00`}</div>
      </div>
    </div>
  );
};

export default HourlyScrollItem;
